<template>
    <svg
        class="va-icon-vuestic"
        :height="height"
        viewBox="0 0 690 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="goHomePage"
    >
        <text
            x="0"
            y="50"
            class="title-top"
            style="
                width: 100%;
                font-size: 40px;
                font-weight: 700;
                fill: rgba(0, 0, 0, 1);
            "
        >
            东风日产数字员工全生命周期管理系统
        </text>

        <defs>
            <linearGradient
                id="paint0_linear"
                x1="0"
                y1="56.1386"
                x2="357.64"
                y2="56.1386"
                gradientUnits="userSpaceOnUse"
            >
                <stop :stop-color="colorsComputed.end" />
                <stop offset="1" :stop-color="colorsComputed.start" />
            </linearGradient>
        </defs>
    </svg>
    <div class="notice-box">
        <div class="scrollText">
            <span
                id="noticeTitle"
                style="cursor: pointer"
                @click.prevent.stop="showMore"
                ><span style="font-size: 18px">公告</span>：{{
                    noticeTitle
                }}</span
            >
        </div>
    </div>

    <vxe-modal
        :title="title"
        v-model="isShow"
        width="900"
        height="600"
        :transfer="true"
        :z-index="99999"
        maskClosable
    >
        <template #default>
            <div style="height: 530px">
                <QuillEditor
                    toolbar="#my-toolbar"
                    ref="quill"
                    style="border-top: 1px solid #d1d5db"
                    :readOnly="true"
                    :enable="false"
                    @ready="showText"
                >
                    <template #toolbar>
                        <div id="my-toolbar" style="display: none"></div>
                    </template>
                </QuillEditor>
            </div>
        </template>
    </vxe-modal>
</template>
<script>
import { useColors } from "vuestic-ui";
import VXETable from "vxe-table";
import Qs from "qs";

export default {
    name: "VaIconVuestic",
    components: {},
    props: {
        height: { type: [Number, String], default: 30 },
        color: { type: [String], default: "primary" },
    },
    data() {
        return {
            noticeTitle: "",
            isShow: false,
            title: "公告",
            text: "",
        };
    },
    computed: {
        colorsComputed() {
            const { getColor, shiftHSLAColor } = useColors();
            const color = getColor(this.color, "primary");

            return { start: color, end: shiftHSLAColor(color, { l: -20 }) };
        },
    },
    methods: {
        showMore() {
            this.isShow = true;
        },
        closeMore() {
            this.isShow = false;
        },
        showText() {
            const quill = this.$refs.quill;
            quill.setHTML(this.text);
        },
        loadData() {
            const params = {
                uid: this.$store.state.userID,
                email: this.$store.state.email,
                currentPage: 1,
                pageSize: 20,
                searchKey: ["-1"],
            };
            this.$api.systemManageAPI
                .getBulletinOne(Qs.stringify(params))
                .then((res) => {
                    if (res.data.Success == false) {
                        VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
                        return;
                    }
                    this.text = res.data.Data.dataTable[0].contents;
                    this.title = "公告 —— " + res.data.Data.dataTable[0].title;
                    this.noticeTitle = res.data.Data.dataTable[0].title;
                    this.dayPopupTimes =
                        res.data.Data.dataTable[0].dayPopupTimes;

                    this.popupBegin = res.data.Data.dataTable[0].popupBegin;
                    this.popupEnd = res.data.Data.dataTable[0].popupEnd;
                    this.enabledPopup = res.data.Data.dataTable[0].enabledPopup;
                    this.closeSecond = res.data.Data.dataTable[0].closeSecond;
                    if (this.enabledPopup == "1") {
                        if (this.dayPopupTimes > 0) {
                            if (this.closeSecond && this.closeSecond > 0) {
                                this.$api.systemManageAPI
                                    .getBulletinShowCount(Qs.stringify(params))
                                    .then((res) => {
                                        if (res.data.Success == false) {
                                            console.log(res.data.Message);
                                            return;
                                        }

                                        if (
                                            res.data.Data < this.dayPopupTimes
                                        ) {
                                            this.showMore();
                                            this.$api.websiteManageAPI.setLoginLog(
                                                Qs.stringify({
                                                    user: this.$store.state
                                                        .userName,
                                                    msg: "公告弹窗显示",
                                                    type: "Bulletin",
                                                    uid: this.$store.state
                                                        .userID,
                                                })
                                            );
                                            setTimeout(() => {
                                                this.closeMore();
                                            }, this.closeSecond * 1000);
                                        }
                                    })
                                    .catch((error) => {
                                        console.log(error);
                                    });
                            }
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        goHomePage() {
            this.$router.push({ path: "/" });
        },
    },
    mounted() {
        this.loadData();
    },
};
</script>

<style scoped>
.notice-box {
    width: 500px;
    height: 100%;
    overflow: hidden;
    margin-left: 20px;

    /* 改成行内 */
    display: inline-block;
}
.scrollText {
    animation: marquee 20s linear infinite;
    color: rgba(212, 48, 48, 1);
    font-size: 18px;
    white-space: nowrap;
    vertical-align: bottom;
}

@keyframes marquee {
    from {
        transform: translateX(100%);
    }
    to {
        transform: translateX(-100%);
    }
}
</style>
